import { render, staticRenderFns } from "./AdminRaceControl.vue?vue&type=template&id=38637046"
import script from "./AdminRaceControl.vue?vue&type=script&lang=js"
export * from "./AdminRaceControl.vue?vue&type=script&lang=js"
import style0 from "./AdminRaceControl.vue?vue&type=style&index=0&id=38637046&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports